import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Landing from "./screens/Landing";
import UserReport from "./screens/UserReport";
import SideMenu from "./components/SideMenu";
import { getUser, isLoggedIn } from "../../utils/auth";
import MentorLogin from "./screens/Login";
import LearningAndDevelopment from "./screens/LearningAndDevelopment";

export default function ExpertView() {
  const location = useLocation();
  const loggedIn = isLoggedIn();
  const user = getUser();

  if (!loggedIn && location.pathname !== "/expert-view/login") {
    return <Navigate to="/expert-view/login" replace />;
  }

  const showSidebar = location.pathname !== "/expert-view/login";

  return (
    <div className="min-h-screen bg-gray-100">
      {showSidebar && <SideMenu user={user} />}

      <main
        className={
          showSidebar
            ? "lg:ml-64 min-h-screen p-4 overflow-x-hidden pt-16 lg:pt-4"
            : "min-h-screen"
        }
      >
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<MentorLogin />} />
          <Route
            path="/report/:userId/:syllabusId/:sessionId"
            element={<UserReport />}
          />
          <Route
            path="/learning-and-development"
            element={<LearningAndDevelopment />}
          />
        </Routes>
      </main>
    </div>
  );
}
